import { localStorageAsync } from "#app/lib/local-storage";

const TOKENS_KEY = "auth_tokens";

export interface StoredTokens {
  accessToken: string;
  refreshToken: string;
}

/**
 * Tokens live in localStorage — a single storage layer runs everywhere the
 * web app runs.
 */
export async function getStoredTokens(): Promise<StoredTokens | null> {
  try {
    const raw = await localStorageAsync.getItem(TOKENS_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed.accessToken && parsed.refreshToken) {
      return parsed as StoredTokens;
    }
    return null;
  } catch {
    return null;
  }
}

export async function setStoredTokens(tokens: StoredTokens): Promise<void> {
  await localStorageAsync.setItem(TOKENS_KEY, JSON.stringify(tokens));
}

export async function clearStoredTokens(): Promise<void> {
  await localStorageAsync.removeItem(TOKENS_KEY);
}
